import type { TopicId } from "@/stores/priorityStore";

export type VoteSnapshot = { ids: TopicId[]; comments: Record<TopicId, string> };

export function buildVoteChanges(previous: VoteSnapshot, current: VoteSnapshot) {
  const previousIds = new Set(previous.ids);
  const currentIds = new Set(current.ids);
  const removed = previous.ids.filter((id) => !currentIds.has(id)).map((target_id) => ({ target_id, selected: false }));
  const changed = current.ids
    .filter((id) => !previousIds.has(id) || (previous.comments[id] ?? "") !== (current.comments[id] ?? ""))
    .map((target_id) => ({ target_id, selected: true, comment: current.comments[target_id] || null }));
  return [...removed, ...changed];
}
